export interface SimplifiedGroup {
  name: string;
}

export function formatGroupName(group: SimplifiedGroup): string {
  return group.name;
}
